/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { useState } from 'react';
import { Col, Stack, Button, Form, InputGroup, Modal } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';

import { SendConfig } from '../Firebase';
import { Item } from '../Fonctions';
import SendMail from '../SendMail';

const schema = yup.object().shape({
	prenom: yup.string().required("Nécessaire"),
	nom: yup.string().required("Nécessaire"),
	codepostal: yup.number().positive().integer().required("Nécessaire"),
	email: yup.string().email().required("Nécessaire"),
});

function ModalDevis({ store_type, commande, compas, securite, largeur, hauteur, couleur, environnement, computeenv, show, onHide, HorsNormes, prix, orientation}) {
	return (
		<Modal
		show={show}
		onHide={onHide}
		size="lg"
		aria-labelledby="contained-modal-title-vcenter"
		centered
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">
					<Item>Vos informations</Item>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Devis
				store_type={store_type}
				commande={commande}
				compas={compas}
				securite={securite}
				largeur={largeur}
				hauteur={hauteur}
				couleur={couleur}
				environnement={environnement}
				computeenv={computeenv}
				HorsNormes={HorsNormes}
				prix={prix}
				orientation={orientation}
				/>
			</Modal.Body>
		</Modal>
	);
}
	
function Devis({ store_type, commande, compas, securite, largeur, hauteur, couleur, environnement, computeenv, HorsNormes, prix, orientation}) {
	const [valid, setValid] = useState(false);

	function handleSubmit(contacts) {
		setValid(true);
		SendConfig(store_type, commande, compas, securite, largeur, hauteur, couleur, environnement, computeenv, contacts, HorsNormes, orientation, prix);
		SendMail(store_type, commande, compas, largeur, hauteur, couleur, environnement, securite, contacts, HorsNormes, computeenv, prix, orientation);
	};

	return (
		<Formik
		validationSchema={schema}
		onSubmit={handleSubmit}
		initialValues={{
			prenom: '',
			nom: '',
			codepostal: '',
			email: '',
		}}>

		{({
			handleSubmit,
			handleChange,
			values,
			touched,
			errors
		}) => (
			<Form noValidate onSubmit={handleSubmit}>
			{/* <h4>Étude personnalisée</h4> */}
			<Stack gap={2}>
			<Stack direction='horizontal' gap={2}>
			<Form.Group as={Col} md="3" controlId="validationFormik01">
			<Form.Control
			type="text"
			name="prenom"
			placeholder='Prénom'
			value={values.prenom}
			onChange={handleChange}
			isValid={!errors.prenom && touched.prenom}
			isInvalid={!!errors.prenom}
			/>
			<Form.Control.Feedback type="invalid">
			{errors.prenom}
			</Form.Control.Feedback>
			</Form.Group>
			<Form.Group as={Col} md="3" controlId="validationFormik02">
			<Form.Control
			type="text"
			name="nom"
			placeholder='Nom'
			value={values.nom}
			onChange={handleChange}
			isInvalid={!!errors.nom}
			isValid={!errors.nom && touched.nom}
			/>
			<Form.Control.Feedback type="invalid">
			{errors.nom}
			</Form.Control.Feedback>
			</Form.Group>
			<Form.Group as={Col} md="3" controlId="validationFormik02">
			<Form.Control
			type="text"
			inputMode='numeric'
			name="codepostal"
			placeholder='Code postal'
			value={values.codepostal}
			onChange={handleChange}
			isInvalid={!!errors.codepostal}
			isValid={!errors.codepostal && touched.codepostal}
			/>
			<Form.Control.Feedback type="invalid">
			{errors.codepostal}
			</Form.Control.Feedback>
			</Form.Group>
			</Stack>
			<Form.Group as={Col} md="8" controlId="validationFormikEmail">
			<InputGroup hasValidation>
			<InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
			<Form.Control
			type="email"
			placeholder="votremail@email.com"
			aria-describedby="inputGroupPrepend"
			name="email"
			value={values.email}
			onChange={handleChange}
			isInvalid={!!errors.email}
			isValid={!errors.email && touched.email}
			/>
			<Form.Control.Feedback type="invalid">
			{errors.email}
			</Form.Control.Feedback>
			</InputGroup>
			</Form.Group>
			<ValidateButton valid={valid}/>
			</Stack>
			</Form>
			)}
		</Formik>
	);
}

function ValidateButton({ valid }) {
	if (!valid)
		return (<Button type="submit" variant='success'>Recontactez moi !</Button>);
	else
		return (<Button disabled variant='success'>Bien reçu ✅</Button>);
}

export default ModalDevis;
